var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"life-cycle"},[_c('div',{staticClass:"start"}),_vm._l((_vm.JourneyList),function(item,index){return _c('div',{key:item,class:[
        'life-cycle-item',
        {
          cur: item === _vm.currentJourney,
          beforeCur: index < _vm.JourneyList.indexOf(_vm.currentJourney),
        } ]},[_c('div',{staticClass:"life-cycle-circle"},[_c('div',{staticClass:"icon"},[_c('i',{class:_vm.iconEnum[item]})]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(item)+" ")])])])}),_c('div',{staticClass:"end"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }